module.exports = __webpack_public_path__ + "static/img/land-img3.b7015a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/land-img3.jpg
// module id = /SQX
// module chunks = 1